import { render, staticRenderFns } from "./PermanentSelfExcludeModal.vue?vue&type=template&id=1f109d0e&"
import script from "./PermanentSelfExcludeModal.vue?vue&type=script&lang=js&"
export * from "./PermanentSelfExcludeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports